
import { Link } from '@inertiajs/react';
import { Button } from 'antd';
import React from 'react'
import { useTranslation } from 'react-i18next';
interface Faqs {
    id: number;
    name: { [key: string]: string }
}
interface Props {
    faqs: Faqs[]
}
export default function Faqs({ faqs }: Props) {
    const { t, i18n } = useTranslation();
    return (
        <div className='m-5 py-5 px-8  grid grid-cols-1'>
            <div className='flex flex-col items-start'>
                <p className=' mb-2  text-custom-dark-blue font-bold text-sm lg:text-base p-4 dark:text-white'>
                    {t('sidebar.Faq')}
                </p>
            </div>
            <div className='flex justify-between items-center xs:flex-wrap'>
                <div className='flex flex-col items-start gap-4'>

                    <div className='flex gap-4 flex-wrap'>
                        {faqs.map((item) =>
                            <Button className='rounded-full font-sans lg:text-base text-sm lg:p-4 p-4 font-bold hover:!bg-custom-dark-blue hover:!text-white hover:!border-white' key={item.id}>
                                <Link href={route('client.faq.index')}>
                                    {item.name[i18n.language]}
                                </Link>
                            </Button>
                        )}
                    </div>

                </div>
                <div>
                    <Link
                    href={route('client.faq.index' , {locale:i18n.language})}
                    >
                    <Button
                        className='rounded-full font-sans lg:text-base text-sm lg:p-4 p-4 font-bold !bg-custom-dark-blue hover:!bg-custom-sky-blue !text-white hover:!text-white hover:!border-white mt-4'
                    >
                        {t('faqs.allfaqs')}
                    </Button>
                    </Link>
                </div>
            </div>

        </div>
    )
}
